import { apiRequest, getSluiceUrl } from "../../../apiHelper/apiRequest";
import { serialize } from "../../../helpers/helpers";


const list = async (params) => {
	return apiRequest(
                        "/settings/list?" + serialize(params),
                        {
                            'method' : "GET"
                        },
                        'ptp_client'
                    );
}


const add = async ( params ) => {
    let options = {};
    if ( params instanceof FormData ) {
        options = {
            'method' : "POST",
            'body' : params
        }
    } else {
        options = {
            'method' : "POST",
            'headers' : {
                'content-type' : 'application/json'
            },
            'body' : JSON.stringify(params)
        };
    }

    let add_response = await apiRequest(
                                        "/settings/add",
                                        options,
                                        'ptp_client'
                                    );
    if ( typeof(add_response.id) !== 'undefined' && add_response.id )
        return add_response.id;
    else
        return 0;
}


const getImageUrl = ( image_path = '' ) => {
    if ( String(image_path).trim() === '' || image_path.indexOf('http') === 0 )
        return image_path;
    return getSluiceUrl('ptp_client') + "/settings/files/" + image_path;
}


const Settings = {
    list,
    add,
    getImageUrl
};
export default Settings;